<template>
  <header class="page-header">
    <section class="page-header__hgroup">
      <NavigationBreadcrumb
        :back="$t('common.navigation.aboutUs')"
        hash="#about"
        :page="$t('common.navigation.team')"
      />
      <h1 v-appear:right="{ delay: 750 }" class="page-header__title">{{ $t('team.header.title') }}</h1>
      <p v-appear:right="{ delay: 825 }">{{ $t('team.header.content') }}</p>
    </section>
  </header>
</template>

<script>
export default {
  name: 'AboutHeader'
}
</script>
